import React, { Component } from 'react';
import { connect } from 'react-redux';
import CodePharmContainer from '../../style/styledComponents/CodePharmContainer';
import ButtonContainer from '../../style/styledComponents/ButtonContainer';
import SendSMSButton from '../../style/styledComponents/SendSMSButton';
import { getPharmaceuticalUnitsList } from '../../_redux/actions/pharmaceutical';

class Pharmaceutical extends Component {
  constructor() {
    super();
    this.state = {
      pharmaceuticalCode: '',
      selectedUnit: ''
    };

    this.handlePharmaceuticalCode = this.handlePharmaceuticalCode.bind(this);
    this.handleSendPharmaceuticalCode = this.handleSendPharmaceuticalCode.bind(this);
    this.handleUnitChange = this.handleUnitChange.bind(this);
  }

  componentDidMount() {
    this.props.getPharmaceuticalUnitsList();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.unitOptions !== this.props.unitOptions) {
    }
  }

  handlePharmaceuticalCode(e) {
    const { value } = e.target;
    // Permitir apenas números e limitar a 6 dígitos
    if (/^\d{0,6}$/.test(value)) {
      this.setState({ pharmaceuticalCode: value });
    }
  }

  handleSendPharmaceuticalCode(e) {
    e.preventDefault();

    this.props.onSend({
      pharmaceuticalCode: this.state.pharmaceuticalCode,
      selectedUnit: this.state.selectedUnit
    });
  }

  handleUnitChange = (e) => {
    this.setState({ selectedUnit: e.target.value });
  };

  render() {
    const { unitOptions } = this.props;

    return (
      <div>
        <label
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginTop: '30px'
          }}>
          <CodePharmContainer className='div-cod-pharm'>
            <span>Matrícula</span>
            <input
              id='codigoFarmaceutico'
              name='codigoFarmaceutico'
              className='form-control'
              type='text'
              placeholder='Digite o código aqui...'
              value={this.state.pharmaceuticalCode}
              onChange={this.handlePharmaceuticalCode}
            />
          </CodePharmContainer>

          <CodePharmContainer className='div-cod-pharm'>
            <span>Sigla da Loja</span>
			<select
				id='unitSelect'
				name='unitSelect'
				className='form-control'
				value={this.state.selectedUnit}
				onChange={this.handleUnitChange}>
				<option value='' disabled>
					Selecione a unidade
				</option>
				{/* Verificar se as opções estão sendo renderizadas */}
				{unitOptions.length > 0 ? (
					unitOptions.map((unit, index) => (
						<option key={index} value={unit.sigla}>
							{unit.sigla} - {unit.loja} ({unit.cidade})
						</option>
					))
				) : (
					<option disabled>Carregando unidades...</option>
				)}
			</select>
          </CodePharmContainer>

          <ButtonContainer className='btn-mobile'>
            <SendSMSButton
              onClick={this.handleSendPharmaceuticalCode}
              disabled={this.props.buttonDisabled}>
              <span>Enviar SMS de pagamento</span>
            </SendSMSButton>
          </ButtonContainer>

          <span style={{ textAlign: 'center', marginTop: '15px' }}>
            O SMS com o link de pagamento será enviado
            <br />
            para o telefone inserido nesse cadastro
          </span>
        </label>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
    return {
        unitOptions: state.Pharmaceutical ? state.Pharmaceutical.unitOptions : []
    };
};

const mapDispatchToProps = {
  getPharmaceuticalUnitsList
};

export default connect(mapStateToProps, mapDispatchToProps)(Pharmaceutical);
